import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Ref https://medium.com/@AurelienLeloup/cache-http-requests-with-rxjs-for-angular-eb9bee93824d
type CacheItem<T> = {
  date: Date;
  value: Observable<T>;
};

@Injectable({
  providedIn: 'root',
})
export class AbstractCacheService<T> {
  readonly CACHE_DURATION_IN_MINUTES = 5;
  readonly DEFAULT_KEY = 'DEFAULT';

  // Uso de Map preferido por sobre un objeto JSON por un tema de rendimiento
  // map.has(key) es más rápido que obj.hasOwnProperty(key) o que obj[key] !== undefined
  // Por otro lado Map permite  tener llaves de cualquier tipo.
  private cache: Map<string | object, CacheItem<T>> = new Map();

  getValue(object?: any): Observable<T> | null {
    const now = new Date();
    const key: string | object = object ? object : this.DEFAULT_KEY;
    const item: CacheItem<T> | undefined = this.cache.has(key) ? this.cache.get(key) : undefined;
    if (!item) {
      return null;
    }

    if (now.getTime() - item.date.getTime() > this.CACHE_DURATION_IN_MINUTES * 60 * 1000) {
      return null;
    }

    return item.value;
  }

  setValue(value: Observable<T>, object?: any) {
    const key = object ? object : this.DEFAULT_KEY;
    const date = new Date();
    this.cache.set(key, { date, value });
  }

  clearCache() {
    this.cache.clear();
  }
}
